import { Play } from 'lucide-react';

const PlayBtn: React.FC = () => {
  return (
    <>
      {/* Play button with white background circle */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-black/30 rounded-full shadow-[0px_6px_7.5px_-4.5px_rgba(0,0,0,0.1)] w-12 h-12 flex items-center justify-center pl-1">
        <Play className="w-5 h-5 text-white fill-white" />
      </div>
    </>
  );
};

export default PlayBtn;
